import BaseApi from '@/services/api/base.api'

class UserApi extends BaseApi {
  async selectBankCodeList(): Promise<IUserBankCodeListSelect.Response> {
    return await this.app.$fetchService.get(
      `${this.craftBaseUrl}/user/bank/code`,
    )
  }

  async updateReferralCode(referralCode: string): Promise<void> {
    return await this.app.$fetchService.post(
      `${this.artistAggregatorBaseUrl}/api/v1/entry-artist/referralcode`,
      {
        referral_code: referralCode,
      },
    )
  }

  async updateValidateBankAccount(
    bankCode: string,
    bankAccountNumber: string,
  ): Promise<IUserValidateBankAccountUpdate.Response> {
    const params: IUserValidateBankAccountUpdate.Request = {
      bank_code: bankCode,
      account: bankAccountNumber,
    }

    return await this.app.$fetchService.post(
      `${this.craftBaseUrl}/user/bank/confirm`,
      params,
    )
  }
}

export default UserApi
